const axiosInstance = require("axios");
const axiosRetry = require("axios-retry");
const qs = require("qs");

// Default behavior is to retry network-related and idempotent functions
// experimentation-id-service itself takes care of segment personas-based issues so we're
// only concerned here with the retries needed from service->experimentation-id-service via http
axiosRetry(axiosInstance, {
  retryDelay: axiosRetry.exponentialDelay
});

function flattenContext(context) {
  const { deviceInfo, ...rest } = context;
  return { ...deviceInfo, ...rest };
}

function getCommonConfig(context, attributes, selectedFeatureKeys = []) {
  return {
    paramsSerializer: params =>
      qs.stringify(params, { encode: false, arrayFormat: "brackets" }),
    params: {
      ...flattenContext(context),
      attributes,
      selectedFeatureKeys
    }
  };
}

function optimizelyHttp(optimizelyHost) {
  function isFeatureEnabled(featureKey, context, attributes) {
    return axiosInstance
      .get(`${optimizelyHost}/open/v2/optimizely/features/${featureKey}`, {
        ...getCommonConfig(context, attributes)
      })
      .then(response => response.data);
  }
  function getEnabledFeatures(context, attributes, selectedFeatureKeys) {
    return axiosInstance
      .get(`${optimizelyHost}/open/v2/optimizely/features`, {
        ...getCommonConfig(context, attributes, selectedFeatureKeys)
      })
      .then(response => response.data);
  }

  function activate(experimentKey, context, attributes) {
    return axiosInstance
      .get(
        `${optimizelyHost}/open/v2/optimizely/experiments/${experimentKey}`,
        {
          ...getCommonConfig(context, attributes)
        }
      )
      .then(response => response.data);
  }

  function getVariation(experimentKey, context, attributes) {
    return axiosInstance
      .get(`${optimizelyHost}/open/v2/optimizely/variation/${experimentKey}`, {
        ...getCommonConfig(context, attributes)
      })
      .then(response => response.data);
  }

  function track(eventKey, context, attributes, eventTags) {
    return axiosInstance
      .post(
        `${optimizelyHost}/open/v2/optimizely/track`,
        {
          eventKey,
          eventTags
        },
        {
          ...getCommonConfig(context, attributes)
        }
      )
      .then(response => response.data);
  }

  return {
    isFeatureEnabled,
    getEnabledFeatures,
    activate,
    getVariation,
    track
  };
}

module.exports = optimizelyHttp;
